export const email = ref('')
export const emailError = ref<string | null>(null)
interface TEmailValid {
    'email.required': string
    'email.invalid': string
}

export function validateEmail(copy: TEmailValid) {
    const emailPattern = /\S[^\s@]*@\S+\.\S+/

    if (!email.value.trim()) {
        emailError.value = copy['email.required']
    } else if (!emailPattern.test(email.value)) {
        emailError.value = copy['email.invalid']
    } else {
        emailError.value = null
    }
}
